import { DeepPartial, PhantomComponentsConfig } from '@empathybroker/ebx-gluon';

export const PHANTOM_CONFIG: DeepPartial<PhantomComponentsConfig> = {
  components: {
    classBinder: {
      data: {
        props: {
          dynamicClasses: {
            'ebx-empathy-x--is-latam':
            // 'es' is the only non latam store currently
              (component: Vue) => component.$store.state.config.dynamic.store !== 'es'
          }
        }
      }
    }
  }
};
